import PropTypes from 'prop-types';
import React from 'react';

export class ImpactTopStat extends React.Component {
  static propTypes = {
    statCount: PropTypes.number.isRequired,
    statNoun: PropTypes.string.isRequired,
    mobile: PropTypes.bool,
  };

  statLabel = () => {
    return $h.pluralize(this.props.statCount, this.props.statNoun);
  };

  statCount = () => {
    if (this.props.loading) {
      return '\u2014'; // mdash
    } else {
      return $h.commaizeInt(this.props.statCount);
    }
  };

  render() {
    return (
      <div className={this.props.mobile ? '' : 'col-xs-4'}>
        <div className="panel panel-flat a-fadeInDown">
          <div className="panel-heading u-tcGrayDarker u-fs18 u-fw300 u-pv10x u-taCenter">
            <div className="u-clearfix">
              <span className="u-fs52 u-lineHeight1">{this.statCount()}</span>
              <div className="u-pt5x u-fw500 u-tcGrayDark">
                {this.statLabel()}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
